import {
  BaseTable,
  Card,
  FooterMenu,
  HeaderMenu,
  Label,
  Loading,
  PaginationData,
  Select,
  TableHeader,
  TableNumber,
} from "components";
import React, { useState } from "react";
import { ApprovalPaymentBillServiceParams } from "./types";
import moment from "moment";
import { useGetListApprovalPaymentBillService } from "./hooks";
import { ApprovalPaymentBillServiceAction } from "./components";
import { approvalChecked } from "utils";

export const dataContext = React.createContext({
  currentPage: 1,
  limit: 10,
  size: 1,
  total: 0,
});

export const PaymentBillServiceApproval = () => {
  const [pagination, setPagination] = useState<ApprovalPaymentBillServiceParams>({
    total: 0,
    page: 1,
    limit: 10,
    pages: 1,
    keyword: "",
    approval_status: "1",
  });
  const listApprovalPaymentBillService = useGetListApprovalPaymentBillService(pagination);

  const approvalDropdowns = [
    {value: "1", label: "PENDING" },
    {value: "3", label: "REJECT"},
    {value: "4", label: "APPROVE"},
  ]

  return (
    <section className="container my-2">
      <section>
        <div className="sticky top-[36px] pt-1 z-[2] bg-white">
          <HeaderMenu title="PAYMENT BILL SERVICE APPROVAL" />
        </div>

        <section>
          <section className="mt-2">
            <Card>
              <Card.Body>
                <div className="justify-end lg:flex items-center">
                  <Label className="mr-2">APPROVAL</Label>
                  <Select
                    className="lg:w-[200px]"
                    placeholder="Select Approval"
                    options={approvalDropdowns}
                    value={approvalDropdowns?.find((item) => item?.value === pagination?.approval_status)}
                    onChange={(e) => setPagination({ ...pagination, approval_status: e?.value })}
                  />
                </div>
              </Card.Body>
            </Card>
          </section>
        </section>

        <section className="mt-2">
          <Card>
            <Card.Body>
              <div className="overflow-x-auto max-h-[calc(100vh-500px)]">
                <BaseTable>
                  <TableHeader>
                    <tr>
                      <th>No</th>
                      <th colSpan={2}>PAYMENT BILL ID#</th>
                      <th>DATE</th>
                      <th>VENDOR</th>
                      <th>LOCATION</th>
                      <th>MEMO</th>
                      <th>APPROVAL STATUS</th>
                      <th>APPROVAL DATE</th>
                    </tr>
                  </TableHeader>
                  <tbody>
                    {listApprovalPaymentBillService.isLoading || listApprovalPaymentBillService?.data?.payload?.listpaymentbill?.length === 0 ? (
                      <tr>
                        <td colSpan={12} className="text-center">
                          <Loading
                            loading={listApprovalPaymentBillService.isLoading}
                            errorText={listApprovalPaymentBillService.isLoading ? "" : "No data available"}
                          />
                        </td>
                      </tr>
                    ) : (
                      listApprovalPaymentBillService?.data?.payload?.listpaymentbill?.map((item, key) => (
                        <tr key={key}>
                          <td className="text-center">{TableNumber({ 
                            dataLength: listApprovalPaymentBillService?.data?.payload?.pagination_data.size, 
                            pageCurrent: pagination?.page, 
                            index: key, 
                            limit: pagination?.limit, 
                            totalData: pagination?.total 
                          })}</td>
                          <td><ApprovalPaymentBillServiceAction data={item} refetch={listApprovalPaymentBillService.refetch} /></td>
                          <td>{item?.trx_code}</td>
                          <td>{moment(item?.transaction_date).format("DD/MM/YYYY")}</td>
                          <td>{item?.vendor_name}</td>
                          <td>{item?.location_name}</td>
                          <td>{item?.memo}</td>
                          <td>{item?.approve_status ? approvalChecked(item?.approve_status) : "-"}</td>
                          <td>{item?.approve_date ? moment(item?.approve_date).format("DD/MM/YYYY") : ""}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </BaseTable>
                <div className="mt-5">
                  <PaginationData
                    data={listApprovalPaymentBillService?.data?.payload}
                    pagination={pagination}
                    setPagination={setPagination}
                  />
                </div>
              </div>
            </Card.Body>
          </Card>
        </section>

        <section className="mt-2">
          <FooterMenu />
        </section>
      </section>
    </section>
  );
}
